import { render, staticRenderFns } from "./AddCommentImageModal.vue?vue&type=template&id=5f0af5dc&scoped=true&"
import script from "./AddCommentImageModal.vue?vue&type=script&lang=js&"
export * from "./AddCommentImageModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCommentImageModal.vue?vue&type=style&index=0&id=5f0af5dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0af5dc",
  null
  
)

export default component.exports